"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProcessRowUpdate = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const constants_1 = require("./table-config/constants");
const use_process_row_update_utils_1 = require("./use-process-row-update.utils");
const client_constants_1 = require("../../../client/client.constants");
const use_update_priority_task_hook_1 = require("../../../client/priority-task/hooks/use-update-priority-task.hook");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const useProcessRowUpdate = ({ filter, sort, pageSize = client_constants_1.PAGE_SIZE_DEFAULT, } = {}) => {
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const apolloClient = (0, react_2.useApolloClient)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedProductTreeId = (0, store_1.useProductTreeId)();
    const { updatePriorityTask } = (0, use_update_priority_task_hook_1.useUpdatePriorityTask)();
    const processRowUpdate = (0, react_1.useCallback)((newRow, oldRow) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const changedField = (0, use_process_row_update_utils_1.getEditableFieldChange)(newRow, oldRow);
        if (!changedField) {
            return oldRow;
        }
        if (!selectedCatalogId || !selectedProductTreeId || !newRow.productTreeNodeId || !newRow.productLabelValidationId) {
            throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
        if (changedField === constants_1.HLQATasksColumns.Priority && !newRow.priority) {
            throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
        if (changedField === constants_1.HLQATasksColumns.Status && !newRow.status) {
            throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
        const { mutationPatch, optimisticRow, shouldShowTaskCountError } = (0, use_process_row_update_utils_1.computeChangeResult)(changedField, newRow);
        if (shouldShowTaskCountError) {
            addError(t({ key: 'VALIDATION_POSITIVE_INTEGER' }));
            return oldRow;
        }
        const queryVariables = {
            catalogId: selectedCatalogId,
            productTreeId: selectedProductTreeId,
            filter,
            sort,
            first: pageSize,
            after: null,
            before: null,
        };
        // Optimistic update: reflect the new value in the visible list immediately.
        (0, use_process_row_update_utils_1.updateEditableFieldsInCache)(apolloClient.cache, queryVariables, optimisticRow);
        try {
            const result = yield updatePriorityTask(Object.assign({ catalog: selectedCatalogId, productTreeId: selectedProductTreeId, productTreeNodeId: newRow.productTreeNodeId, productLabelValidationId: newRow.productLabelValidationId, clientMutationId: '' }, mutationPatch));
            if (!((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.updatePriorityTask) === null || _b === void 0 ? void 0 : _b.success)) {
                throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            }
            return newRow;
        }
        catch (_c) {
            // Roll back optimistic value on backend error.
            (0, use_process_row_update_utils_1.updateEditableFieldsInCache)(apolloClient.cache, queryVariables, oldRow);
            throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
    }), [addError, apolloClient.cache, filter, pageSize, selectedCatalogId, selectedProductTreeId, sort, t, updatePriorityTask]);
    const processRowUpdateError = (0, react_1.useCallback)((error) => {
        addError(error.message || t({ key: 'GENERAL_ERROR_MESSAGE' }));
    }, [addError, t]);
    return {
        processRowUpdate,
        processRowUpdateError,
    };
};
exports.useProcessRowUpdate = useProcessRowUpdate;
